import HubWelcomeContent from '../../../shared/components/HubWelcomeContent';
import { useGetAccountDataQuery } from '../../../shared/navigation/apiSlice';
import { AdminInfo } from '../models';
import styles from '../productcard.module.scss';

export default function Welcome({
  accountId,
  adminInfo,
}: {
  accountId: string;
  adminInfo: AdminInfo;
}) {
  const { data: accountData, isLoading } = useGetAccountDataQuery(accountId);

  if (isLoading) return null;

  return (
    <div className="d-grid col-12">
      <div className="card-container d-grid mb-4">
        <div className={`card p-2 p-lg-3 ${styles.productCard}`}>
          <HubWelcomeContent
            content={accountData?.welcome?.content}
            logoUrl={accountData?.logoUrl}
            title={accountData?.welcome?.title}
            videoUrl={accountData?.welcome?.video?.videoUrl}
            transcript={accountData?.videoTranscriptData}
            adminInfo={adminInfo}
          />
        </div>
      </div>
    </div>
  );
}
